import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";

export default async function apontamentoReport(indicador, visita) {
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const h = new TableReportHelper(apontamento);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);
        const additionalColumn = {
            label: "Operador",
            field: "operador.operador",
            width: "*",
        };

        content.push([
            await apontamentoHeaderLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                params,
                undefined,
                undefined,
                additionalColumn,
            ),

            h.panel(
                [
                    h.row(
                        h.title("Aferição"),
                        h.title("Dosagem Recomendada"),
                        h.title("Dose/Metro"),
                        h.title("Insumo"),
                        h.title("Soma das Pesagens (Kg)"),
                    ),

                    h.row(
                        h.numberField("afericao"),
                        h.numberField("dosagemRecomendada"),
                        h.numberField("doseMetro"),
                        h.textField("insumo.nomeInsumo"),
                        h.numberField("totalPesagem", { digits: 3 }),
                    ),
                ],
                { widths: [60, "*", 90, "*", 110] },
            ),

            await apontamentoColetasLocalizacaoReport(
                visita,
                indicador,
                apontamento,
                ["Pesagem (Kg)"],
                // prettier-ignore
                (h) => [
                    h.numberField("pesagem", { digits: 3 }),
                ],
                [60],
            ),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }

    return content;
}
